module.exports = __webpack_public_path__ + "static/media/Insta-image-1.5b412f14.jpeg";